import { ClippingParameterModel } from './ClippingParameterModel';

export interface ClipperModel {
    id: number,
    name: string,
    lineStart: number,
    columnIdNews: string,
    columnTitle: string,
    columnNewsLink: string,
    columnClipperLink: string,
    columnPublishDate: string,
    columnJournalist: string,
    columnPublicationPlace: string,
    columnCentimeter: string,
    columnMedia: string,
    clippingUrl: string,
    active: boolean,
    userId: number | null,
    clippingParameters: ClippingParameterModel[],
    clipperIdCopy: number,
    storageSettingsExists: boolean,
    mediaDictionarySettingsExists: boolean,
    copySettings: boolean
}

export const clipperDataInitial: ClipperModel = {
    id: 0,
    name: '',
    lineStart: 0,
    columnIdNews: '',
    columnTitle: '',
    columnNewsLink: '',
    columnClipperLink: '',
    columnPublishDate: '',
    columnJournalist: '',
    columnPublicationPlace: '',
    columnCentimeter: '',
    columnMedia: '',
    clippingUrl: '',
    active: false,
    userId: null,
    clippingParameters: [],
    clipperIdCopy: 0,
    storageSettingsExists: false,
    mediaDictionarySettingsExists: false,
    copySettings: false
};